import Vue from 'vue';
import Vuex from 'vuex';

import layout from './layout';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    layout,
  },
  state:{
    var1: 'hello',
    activeSite: {
      id: null,
      demo: false,
      url: '',
      uuid: '',
      devices:[]
    },
    user: {},
    scanStatus: {
      completed: true,
      statusText: 'completed',
      site: {
        crawlCompleted: true,
        status: 'completed',
        statusText: 'Completed',
        errors: [],
        linkCheckCompleted: true,
        spellCheckCompleted: true,
      },
      pageErrors:[],
      pages: []
    },
  },
  actions: {
    reloadAll(context){
      return context.commit("setSettings", {})
    },
  },
  mutations: {
    setSettings(state, data){
    },
    setActiveSite(state, site){
      state.activeSite = site;
    },
    setScanStatus(state, status){
      state.scanStatus = status;
    },
    setUser(state, user){
      state.user = user;
    }
  }
});
